import { personNameSchema } from '@1trading/fast-api-domain/forms';
import { z } from 'zod';

import i18n from '@/lib/i18n';
import { nameErrors } from '@/utils/error-messages';

export const futuresClientCategorisationProfessionalAgreementSchema = z
  .object({
    date: z.iso.date(),
    name: personNameSchema({ errors: nameErrors('FuturesAppropriatenessClientCategorisation.professionalAgreement.errors.name') }),
    signature: personNameSchema({ errors: nameErrors('FuturesAppropriatenessClientCategorisation.professionalAgreement.errors.signature') }),
  })
  .superRefine((data, ctx) => {
    if (data.name.toLowerCase() !== data.signature.toLowerCase()) {
      ctx.addIssue({
        code: 'custom',
        message: i18n.t('FuturesAppropriatenessClientCategorisation.professionalAgreement.errors.nameSignatureMismatch'),
        path: ['signature'],
      });
    }
  });

export type FuturesClientCategorisationProfessionalAgreement = z.infer<typeof futuresClientCategorisationProfessionalAgreementSchema>;
